import React, { Component } from 'react';
import { Input } from 'reactstrap';
import swal from 'sweetalert2/dist/sweetalert2.min.js';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import './index.css'

class Settings extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searchTerm: '',
            field: '',
            showAlert: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.filteredData = this.props.tableData;
    }

    componentDidMount = () => {
        this.props.filter &&
            this.setState({
                field: this.props.columns["0"].key
            })
    }

    handleChange = (evt) => {
        this.setState({ [evt.target.name]: evt.target.value });
    }



    closeModal = () => {
        this.props.history.replace('/admin/app/sellers');
        window.location.reload();
    }

    handleDelete = (action) => {
        swal({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.value) {
                const data = {
                    'seller_id': this.props.sellerId
                }
                this.props.dispatch(action.deleteSeller(data))
                this.closeModal()
            }
        });
    }


    filterList = (evt) => {

        var searchTerm = evt.target.value;
        this.filteredData = this.props.sellers.filter(
            (data) => {

                if (data[this.state.field] !== null) {
                    return (data[this.state.field].toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1);
                }
            }
        )
        this.props.view(this.filteredData);
    }

    render() {
        const columns = this.props.columns !== undefined ? this.props.columns : '';
        const { buttonData } = this.props;



        return (
            <div className="bg-gray container animation-fade-in">
                <div className="row p-2">
                    <div className={this.props.filter === true ? "col-md-6" : "col-md-12"}>
                        <div className="row align-items-center">
                            <div className="col-1 pr-3 pl-1 border-white ">
                                <i className="fas fa-cog text-white" />
                            </div>
                            <div className="col-11 borderLeft">
                                <div className="d-flex flex-row flex-wrap">
                                    {
                                        this.props.buttonData.map(
                                            (element, i) => {
                                                return <div key={i} className="col-md- pr-0">
                                                    <button className="btn btn-red btn-sm text-uppercase mx-1 mb-1 mb-md-0" style={{ fontSize: 12, padding: '4px 14px' }} onClick={() => { element.toggler(!element.togglerModal); this.props.modal(!this.props.showModal) }} >{element.heading}</button>
                                                </div>
                                            }
                                        )
                                    }
                                </div>
                            </div>






                        </div>
                    </div>
                    <div className="col-md-6">
                        {
                            this.props.filter === true &&
                            <div className="row align-items-center">
                                <div className="col-1 pr-3 pl-1 border-white ">
                                    <i className="fas fa-search text-white" />
                                </div>
                                <div className="col-5 borderLeft" style={{ position: 'relative' }}>
                                    <i className="fas fa-sort-down text-white filterIcon2"></i>
                                    <Input
                                        defaultValue="state"
                                        type="select" name="field"
                                        bsSize="sm" className="filterOption text-white border-radius-zero"
                                        onChange={this.handleChange}
                                    >
                                        {columns.map(function (column, index) {
                                            return <option className="bg-gray" value={column.key} key={index}>{column.name}</option>;
                                        })}
                                    </Input>
                                </div>
                                <div className="input-group input-group-sm col-6 px-0">
                                    <input type="text" className="form-control mx-1 mb-1 mb-md-0 border-radius-zero" aria-label="search" placeholder="Search..." aria-describedby="search" name="searchTerm"
                                        onChange={this.filterList}
                                    />
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div >
        )
    }
}

function mapStateToProps(state) {

    return {
        state
    };

}

const connectedPage = connect(mapStateToProps)(Settings);
export default withRouter(connectedPage); 


// WEBPACK FOOTER //
// ./src/_components/common/SettingsHeader/index.jsx